import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { IDirectReportsWithTimeStatus } from '../IDirectReportsWithTimeStatus';

export const getDirectReportsWithTimeStatus = createAction(
  '[TimeCard/API] Get Direct Reports With Time Status',
  props<{ UserListID: string, UserRole: number, EmployeeListID?: string, StartDate?: string, EndDate?: string, MyDRsOnly?: boolean }>()
);

////////////////////////////////////////////////////////////////////////////////////

export const loadDirectReportsWithTimeStatuss = createAction(
  '[DirectReportsWithTimeStatus/API] Load DirectReportsWithTimeStatuss',
  props<{ directReportsWithTimeStatuss: IDirectReportsWithTimeStatus[] }>()
);

export const addDirectReportsWithTimeStatus = createAction(
  '[DirectReportsWithTimeStatus/API] Add DirectReportsWithTimeStatus',
  props<{ directReportsWithTimeStatus: IDirectReportsWithTimeStatus }>()
);

export const upsertDirectReportsWithTimeStatus = createAction(
  '[DirectReportsWithTimeStatus/API] Upsert DirectReportsWithTimeStatus',
  props<{ directReportsWithTimeStatus: IDirectReportsWithTimeStatus }>()
);

export const addDirectReportsWithTimeStatuss = createAction(
  '[DirectReportsWithTimeStatus/API] Add DirectReportsWithTimeStatuss',
  props<{ directReportsWithTimeStatuss: IDirectReportsWithTimeStatus[] }>()
);

export const upsertDirectReportsWithTimeStatuss = createAction(
  '[DirectReportsWithTimeStatus/API] Upsert DirectReportsWithTimeStatuss',
  props<{ directReportsWithTimeStatuss: IDirectReportsWithTimeStatus[] }>()
);

export const updateDirectReportsWithTimeStatus = createAction(
  '[DirectReportsWithTimeStatus/API] Update DirectReportsWithTimeStatus',
  props<{ directReportsWithTimeStatus: Update<IDirectReportsWithTimeStatus> }>()
);

export const updateDirectReportsWithTimeStatuss = createAction(
  '[DirectReportsWithTimeStatus/API] Update DirectReportsWithTimeStatuss',
  props<{ directReportsWithTimeStatuss: Update<IDirectReportsWithTimeStatus>[] }>()
);

export const deleteDirectReportsWithTimeStatus = createAction(
  '[DirectReportsWithTimeStatus/API] Delete DirectReportsWithTimeStatus',
  props<{ id: string }>()
);

export const deleteDirectReportsWithTimeStatuss = createAction(
  '[DirectReportsWithTimeStatus/API] Delete DirectReportsWithTimeStatuss',
  props<{ ids: string[] }>()
);

export const clearDirectReportsWithTimeStatuss = createAction(
  '[DirectReportsWithTimeStatus/API] Clear DirectReportsWithTimeStatuss'
);
